import { render, staticRenderFns } from "./AudioVisualTips.vue?vue&type=template&id=42538a1c&"
import script from "./AudioVisualTips.vue?vue&type=script&lang=ts&"
export * from "./AudioVisualTips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports